// extracted by mini-css-extract-plugin
export default {"Section":"_Section--hjJOp","ConfirmationArea":"_ConfirmationArea--RnKCF","ActionButtons":"_ActionButtons--iBZd6"};